import { Checkbox, FilterWrapper } from "components/common/elastic/style";
import { useEffect, useRef } from "react";
import { appendClassName } from "utils";

import type { FacetViewProps } from "../interface";

const ReverseBooleanFacet = ({
  className,
  label,
  options,
  onRemove,
  onChange,
  values
}: FacetViewProps) => {
  /* Denne er bakvendt, til fordel for "vis inaktive koder".
			Fordi, inaktive koder har en false verdi, og aktive koder har en true verdi.
			For å vise inaktive koder, må vi derfor velge false.
			Som går i mot de andre, der man må velge true verdien.
	*/
  const hasInitialized = useRef(false);

  const falseOptions = options.find((option) => option.value === "false");
  // The checkbox is selected when both 'true' and 'false' are in values
  const isSelected = values.includes("false");
  // Disable if there are no 'false' options in our results
  const isDisabled = !falseOptions;

  const handleToggle = () => {
    if (isSelected) {
      // When unchecking, remove 'false' to show only 'true' values
      onRemove("false");
    } else {
      // When checking, show both "true" and "false" values
      onChange(["false", "true"]);
    }
  };

  useEffect(() => {
    // Set initial filter to only show "true" values (deselected state)
    // Only initialize once on mount if no values are set
    if (!hasInitialized.current && values.length === 0) {
      hasInitialized.current = true;
      onChange(["true"]);
    }
  }, [values.length, onChange]);

  return (
    <FilterWrapper className={appendClassName(className)}>
      <Checkbox
        type="checkbox"
        label={label}
        id={`facet-${label}`}
        name={`facet-${label}`}
        disabled={isDisabled}
        checked={isSelected}
        onChange={handleToggle}
        style={{ fontWeight: isSelected ? "bold" : "normal" }}
      />
    </FilterWrapper>
  );
};

export default ReverseBooleanFacet;
